/** Open lots with available qty (backend requires lot_id when any such lot exists). */
export function availableLots(lots) {
  if (!Array.isArray(lots)) return [];
  return lots.filter((lot) => Number(lot.qty) > 0);
}

/**
 * Resolve barcode/lots payload into add-to-cart or pick-lot action.
 * Feature-detect: if `lots` key missing (`hasLots` false) → legacy META-only.
 * When open lots with qty > 0 exist → lot_id required on POS/stock.
 */
export function resolveLotForCart({ item, lots, lotPickRequired, hasLots }) {
  if (!hasLots || !Array.isArray(lots)) {
    return {
      action: 'add',
      item,
      lotId: null,
      unitPrice: item.price,
      lotQty: item.stock,
      requiresLot: false,
    };
  }

  const open = availableLots(lots);
  if (open.length === 0) {
    // Lots key present but nothing sellable — legacy-ish META path; server won't require lot_id.
    return {
      action: 'add',
      item,
      lotId: null,
      unitPrice: item.price,
      lotQty: item.stock,
      requiresLot: false,
    };
  }

  const distinctPrices = [...new Set(open.map((l) => Number(l.sellingPrice)))];
  const needsPick = lotPickRequired || distinctPrices.length > 1;
  if (needsPick) {
    return { action: 'pick_lot', item, lots: open, requiresLot: true };
  }

  const lot = open[0];
  return {
    action: 'add',
    item,
    lotId: lot.lotId,
    unitPrice: lot.sellingPrice,
    lotQty: lot.qty,
    mrp: lot.mrp,
    requiresLot: true,
  };
}

export function cartLineKey(itemId, lotId) {
  return lotId ? `${itemId}::${lotId}` : itemId;
}

export function lotsDisagreeWithMeta(lots, metaPrice) {
  if (!lots?.length) return false;
  const meta = Number(metaPrice);
  return lots.some((lot) => Number(lot.sellingPrice) !== meta);
}

export function lotPriceRange(lots) {
  if (!lots?.length) return null;
  const prices = lots.map((l) => Number(l.sellingPrice));
  return { min: Math.min(...prices), max: Math.max(...prices) };
}
